export class PollListRecord {

    pollId: number;
    pollTitle: string;

    openDate: Date;
    closeDate: Date;
    resultsDate: Date;
    updateDate: Date;

    publishedFlag: boolean;

    ownerId: number;
    ownerFirstName: string;
    ownerLastName: string;

    userResponsesNum: number;
    anonResponsesNum: number;


    publicGroupsNum: number;
    groupsNum: number;

    activeSessionsNum: number;
}

export class PageInfo {
    page: number;
    pageSize: number;
    totalRecordsNum: number;
    sort: string;
    sortDir: string;
    hasPolls: boolean;
}

